module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "reportView page right-side",
    attrs: {
      "size": "A4"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5cbb747c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/reports/ReportBasic.vue
// module id = 712
// module chunks = 0